export var SENTRY_RELEASE = "2ddd245031c88eab30f41a3f0b421fa7ef7e6f9f";
